import { render, staticRenderFns } from "./card-bs.vue?vue&type=template&id=0552204f"
import script from "./card-bs.vue?vue&type=script&lang=js"
export * from "./card-bs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports